// extracted by mini-css-extract-plugin
export default {"googleButton":"scU0H","marginArea":"reI3P"};